import { TrendResult } from '@/models/student/student-trends';
import { EChartService } from '@/service/echart/echart.service';
import { NumberUtils } from '@/utils/number.utils';
import i18n from '@/i18n';

export class TrendEchartService extends EChartService {
  latestResults: TrendResult[] = [];

  constructor() {
    super();
  }

  setTrendScores(latestResults: TrendResult[]) {
    this.latestResults = latestResults;
  }

  get hasOverflowData(): boolean {
    return this.latestResults.filter(d => d.trendScore >= 2 || d.trendScore <= -2).length > 0;
  }

  /**
   * AIGROW2-184 箱ひげ図にデータテーブルを追加
   * 箱ひげ図のみにデータを表形式で表示する
   * EChartService が箱ひげ図以外のグラフでも共通なので、空配列を返すだけのものを追加しています
   * subTableColmuns
   * subTableData
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  addSeries(): void {}

  get options() {
    let gridOptions = { width: '100%', containLabel: true, left: '0%', right: '0%' };
    const HUMANITIES: string = '（' + i18n.t('HUMANITIES').toString() + '）';
    const SCIENCES: string = '（' + i18n.t('SCIENCES').toString() + '）';

    return {
      tooltip: { show: false, trigger: 'axis', axisPointer: { type: 'shadow' } },
      grid: {
        top: 0,
        bottom: 0,
        show: true,
        width: `${gridOptions.width}%`,
        height: '99%',
        left: `${gridOptions.left}%`,
        right: `${gridOptions.right}%`,
      },
      xAxis: [
        {
          type: 'value',
          position: 'top',
          splitLine: { lineStyle: { type: 'dashed' } },
          min: this.hasOverflowData ? -2.5 : -2,
          max: this.hasOverflowData ? 2.5 : 2,
          axisLabel: { color: 'rgba(0,0,0,0.0)' },
        },
      ],
      yAxis: [
        {
          type: 'category',
          // nameGap: 0,
          axisTick: { show: false },
          axisLabel: { height: '11px' },
          // data: this.titles(true),
        },
        {
          type: 'category',
          // nameGap: 0,
          axisTick: { show: false },
          axisLabel: { height: '11px' },
          // data: this.titles(false),
        },
      ],
      series: [
        {
          name: 'category',
          type: 'bar',
          barWidth: 40,
          label: {
            normal: {
              show: true,
              position: 'inside',
              align: 'center',
              fontSize: 15,
              formatter: function(d: any) {
                const baseScore = NumberUtils.plusFloorAndMinusCeil(d.value * 50);
                let displayScore = baseScore;
                let additionalWord = '';
                if (d.data.isHumanitiesOrSciences) {
                  displayScore = Math.abs(baseScore);
                  if (d.value > 0) {
                    additionalWord = SCIENCES;
                  } else if (d.value < 0) {
                    additionalWord = HUMANITIES;
                  }
                }
                return `${d.data.displayTrendName}${additionalWord}\n${displayScore}`;
              },
            },
          },
          // itemStyle: { normal: { color: this.barColor } },
          data: this.latestResults
            .map((d: TrendResult) => {
              return { value: d.trendScore, itemStyle: { normal: { color: d.color } }, isHumanitiesOrSciences: d.isHumanitiesOrSciences, displayTrendName: d.displayTrendName };
            })
            .reverse(),
        },
      ],
    };
  }
}
